export default __webpack_public_path__ + "static/media/cardReportDetails.e872eaeb.svg";